import React from "react";
import { errorId, } from "@rjsf/utils";
/** The `FieldErrorTemplate` component renders the errors local to the particular field
 *
 * @param props - The `FieldErrorProps` for the errors being rendered
 */
export default function FieldErrorTemplate(props) {
    const { errors = [], idSchema } = props;
    if (errors.length === 0) {
        return null;
    }
    const id = errorId(idSchema);
    return (React.createElement("ul", { className: "list-inside list-none", id: id }, errors.map((error, i) => {
        return (React.createElement("li", { key: i, className: "m-0 border-0 p-0" },
            React.createElement("small", { className: "m-0 text-red-500" }, error),
            " "));
    })));
}
//# sourceMappingURL=FieldErrorTemplate.js.map